import DefaultLayout from './DefaultLayout';

export { DefaultLayout };



// WEBPACK FOOTER //
// ./src/containers/index.js